module.exports = __webpack_public_path__ + "assets/img/The_Benefits_of_Listing_cn.67779e6e.png";